import { useMemo } from "react";
import { useAPIKeyContext } from "../contexts/api-key-context";
import { useClerkToken } from "./use-clerk-token";

/**
 * Resolves the authentication token to use for API requests.
 *
 * Priority:
 * 1. Explicit token override (if provided)
 * 2. Clerk token (if available and API key context is active)
 * 3. API key (if Clerk token is unavailable)
 * 4. Clerk token (default)
 */
export function useAuthToken(tokenOverride?: string): string | null {
  const { token } = useClerkToken();
  const { apiKey } = useAPIKeyContext();

  return useMemo(() => {
    if (tokenOverride) return tokenOverride;
    if (apiKey) {
      if (token) return token;
      return apiKey;
    }
    return token;
  }, [tokenOverride, apiKey, token]);
}
